// .u_amo-member-directory-filters
class UAMOMemberDirectoryFilters extends Uneet {
  constructor (domElement, searchCallback = null, clearCallback = null) {
    super(domElement)
    this.isAdvancedShown = false
    this.selects = []
    this.inputs = []
    this.checkboxes = []
    this.searchCallback = (searchCallback !== null) ? searchCallback : this.__noop
    this.clearCallback = (clearCallback !== null) ? clearCallback : this.__noop
    this.__init()
  }

  __init () {
    const filterToggleBtn = this._e.querySelectorAll('button.advanced-filters-toggle')[0]
    filterToggleBtn.onClick((ev) => {
      this.toggleAdvancedFilters()
    })

    this.__generateSubUneets()

    const searchBtn = this._e.querySelectorAll('button.directory-search')[0]
    searchBtn.onClick((ev) => {
      this.onSearchClick()
    })

    const clearBtn = this._e.querySelectorAll('button.clear-fields')[0]
    clearBtn.onClick((ev) => {
      this.onClearClick()
    })
  }

  __generateSubUneets () {
    const selects = this._e.querySelectorAll('.u_amo-select')
    selects.forEach((e) => {
      let thisSelect = new UAMOSelect(e, (ev) => {
        // console.log(this.getFilterURLEncodedString())
      })
      this.selects.push(thisSelect)
    })

    const inputs = this._e.querySelectorAll('.u_amo-input')
    inputs.forEach((e) => {
      let thisInput = new UAMOInput(e, (ev) => {
        // console.log(this.getFilterURLEncodedString())
      })
      this.inputs.push(thisInput)
    })

    const checkboxes = this._e.querySelectorAll('.u_amo-checkbox')
    checkboxes.forEach((e) => {
      let thisCheckbox = new UAMOCheckbox(e, (ev) => {
        // console.log(this.getFilterURLEncodedString())
      })
      this.checkboxes.push(thisCheckbox)
    })
  }

  onSearchClick () {
    this.searchCallback()
  }

  onClearClick () {
    this.inputs.forEach((obj) => {
      obj.clear()
    })
    this.checkboxes.forEach((obj) => {
      obj.clear()
    })
    this.selects.forEach((obj) => {
      obj.clear()
    })
    this.clearCallback()
  }

  toggleAdvancedFilters (force = null) {
    if (force === null) {
      this.isAdvancedShown = !this.isAdvancedShown
    } else {
      this.isAdvancedShown = force
    }

    this._e.toggleClass('isAdvancedShown', this.isAdvancedShown)
  }

  getFilterURLEncodedString () {
    let finalString = ''
    this.inputs.forEach((obj) => {
      let thisVal = obj.getURLEncodedValue()
      if (thisVal !== '') {
        finalString = `${finalString}${obj.varname}=${thisVal}&`
      }
    })
    this.checkboxes.forEach((obj) => {
      let thisVal = obj.getURLEncodedValue()
      if (thisVal !== encodeURIComponent(false)) {
        finalString = `${finalString}${obj.varname}=${thisVal}&`
      }
    })
    this.selects.forEach((obj) => {
      let thisVal = obj.getURLEncodedValue()
      if (thisVal !== encodeURIComponent(JSON.stringify([]))) {
        finalString = `${finalString}${obj.varname}=${thisVal}&`
      }
    })
    return finalString
  }
}
